export const hash = 'b0016d51-1e43-4f9f-8aea-1dc065d0050f';

// export const gateKey = '';
export const gateKey = 'ek_live_g5Df6bp6y5ptAKeOVOpBloZHmqY0sb';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';



//export const apiSocket = 'http://localhost:8080';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const websitePath = 'https://congresso.sbmh.com.br';
export const urlWebsite = 'https://congresso.sbmh.com.br';
export const supportNumber = `555195181533`;
export const home = 'Home';
export const haveTranslate = false;
export const defaultProjectHash = 'sbmh';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = '10º CBMH';
export const logo = '/assets/logo.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = '10º CBMH';
export const dadosOrganizacao = '';
export const social = {
    whatsapp: '',
    instagram: '',
    facebook: '',
    linkedin: '',
    youtube: '',
    spotify: '',
    twitter: '',
};


export const defaultTheme = {
    defaultBackground: '#0F2350',
    defaultColor: '#fff',
    logo: {
        minWidth: '450px',
    },
    menu: {
        background: '#0F2350',
        backgroundSticky: '#0F2350',
        backgroundMobile: '#0F2350',
        color: '#fff',
        shadow: '0',
        logoColor: 'none',
    },
};

export const getToken = (): string | null => {
    const token = localStorage.getItem(`@${authTitle}:token`);
    return token;
};
